var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelfLocal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bee5ee;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logitipo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.33,12.87a3.31,3.31,0,0,0-2.83-.64c-.74.3-1.21,1.46-1.68,2a.73.73,0,0,1-.92.2A12.92,12.92,0,0,1,5.49,9a.78.78,0,0,1,.1-1.07A4.29,4.29,0,0,0,6.75,6a4.12,4.12,0,0,0-.52-2.24A5.29,5.29,0,0,0,4.58,1.29a2.28,2.28,0,0,0-2.46.36,5,5,0,0,0-1.73,4A5.22,5.22,0,0,0,.55,6.86a10.09,10.09,0,0,0,1.2,2.78A21.71,21.71,0,0,0,3,11.55a19.48,19.48,0,0,0,5.45,5.06,16.84,16.84,0,0,0,3.4,1.62,7.57,7.57,0,0,0,4,.62,4.8,4.8,0,0,0,3.59-2.67,2.29,2.29,0,0,0,.17-1.36C19.36,13.88,18.09,13.32,17.33,12.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelfLocal);
export default __webpack_public_path__ + "static/media/icon-telf-local.421605694809e6240410dc4f2a8fcbaa.svg";
export { ForwardRef as ReactComponent };